<template>
 <div>


    <b-modal
      title="Información Extra"
      size="md"
      class="modal-primary"
      hide-footer
      v-model="show"
    >
      <div>
         <b-row>
            <b-col sm="12">
                <b-form-group description label="Número Embarque">
                    <b-form-input
                    type="text"
                    v-model="extraInfoWaybillObj.shipping_number"
                    placeholder
                    />
                </b-form-group>
                </b-col>

                <b-col sm="12">
                <b-form-group description label="Número Contenedor">
                    <b-form-input
                    type="text"
                    v-model="extraInfoWaybillObj.container_number"
                    placeholder
                    />
                </b-form-group>
            </b-col>
         </b-row>

            <b-button variant="primary" class="pull-center" @click.stop="show=false" >Ok</b-button>

      </div>
    </b-modal>
 </div>
</template>

<script>

	export default {
        name: 'ExtraInfoWaybill',
        props:["extraInfoWaybillObj","visible"],
        computed: {
            show: {
                get () {
                    return this.visible;
                },
                set (value) {
                    if (!value) {
                    this.$emit('close');
                    }
                }
            }
        },
		methods: {
			recoverPasswordSubmit(){
				
            }
            
		},
	}
</script>